import { render, staticRenderFns } from "./ClassDetail.vue?vue&type=template&id=6fe1b6c1"
import script from "../../controllers/class/class-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/class/class-detail.js?vue&type=script&lang=js&external"
import style0 from "./ClassDetail.vue?vue&type=style&index=0&id=6fe1b6c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports